import React from "react";
import PropTypes from "prop-types";

const Message = ({ notification }) => {
  return (
    <div>
      <h4>{notification.title}</h4>
      <p>{notification.body}</p>
    </div>
  );
};

Message.propTypes = {
  notification: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }).isRequired,
};

export default Message;
